<template>
    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-default shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg pb-300">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 font-weight-light text-uppercase text-white">
                            Nous contacter
                        </h2>
                        <p class="lead text-white">
                            Que vous soyez client ou producteur en Occitanie,
                            vous pouvez nous contacter via ce formulaire ! Nous tâcherons de vous répondre dans les plus brefs délais.
                            <br />
                            <span><b>Amicalement les Azterriens !</b></span>
                        </p>
                    </div>
                </div>

            </div>
        </section>
        <section class="section section-lg pt-lg-0 section-contact-us">
            <div class="container">
                <div class="row justify-content-center mt--300">
                    <div class="col-lg-8">
                        <card
                            gradient="secondary"
                            shadow
                            body-classes="p-lg-5"
                        >
                            <h4 class="mb-1">Vous souhaitez nous laisser un message ?</h4>
                            <p class="mt-0">Vos messages sont importants pour nous.</p>
                            <ValidationObserver v-slot="{ invalid }">
                                <form @submit.prevent="sendEmail">

                                    <ValidationProvider
                                        name="nom"
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <span class="text-danger">
                                            <em>
                                                <small>
                                                    {{ errors[0] }}
                                                </small>
                                            </em>
                                        </span>
                                        <base-input
                                            type="text"
                                            v-model="name"
                                            name="name"
                                            placeholder="Votre nom"
                                            addon-left-icon="ni ni-user-run"
                                            alternative
                                        >
                                        </base-input>

                                    </ValidationProvider>

                                    <ValidationProvider
                                        name="email"
                                        rules="required|email"
                                        v-slot="{ errors }"
                                    >
                                        <span class="text-danger">
                                            <em>
                                                <small>
                                                    {{ errors[0] }}
                                                </small>
                                            </em>
                                        </span>
                                        <base-input
                                            type="email"
                                            v-model="email"
                                            name="email"
                                            placeholder="Votre email"
                                            addon-left-icon="ni ni-email-83"
                                            alternative
                                        >
                                        </base-input>
                                    </ValidationProvider>

                                    <ValidationProvider
                                        name="message"
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <span class="text-danger">
                                            <em>
                                                <small>
                                                    {{ errors[0] }}
                                                </small>
                                            </em>
                                        </span>
                                        <base-input class="mb-4">
                                            <textarea
                                                v-model="message"
                                                name="message"
                                                rows="4"
                                                cols="80"
                                                class="form-control form-control-alternative"
                                                placeholder="Votre message..."
                                            ></textarea>
                                        </base-input>
                                    </ValidationProvider>
                                    <base-button
                                        nativeType="submit"
                                        type="pink"
                                        round
                                        block
                                        size="lg"
                                        :disabled="invalid"
                                    >
                                        Envoyer le message
                                    </base-button>
                                </form>
                            </ValidationObserver>
                        </card>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import emailjs from 'emailjs-com'
export default {
  name: 'ContactUs',
  data() {
    return {
      name: '',
      email: '',
      message: '',
    }
  },
  methods: {
    sendEmail(e) {
      try {
        emailjs.sendForm(
          'service_p48vjlr',
          'template_ky5qs4m',
          e.target,
          'user_tO9sSeMxUjkR3vaEx5H7t',
          {
            name: this.name,
            email: this.email,
            message: this.message,
          }
        )
      } catch (error) {}
      this.$alert('Votre message à bien été transmis', 'Merci !', 'success')
      // Reset form field
      this.name = ''
      this.email = ''
      this.message = ''
    },
  },
}
</script>